/**
 * RoleService
 * Service for Role entity operations
 * Route: api/roles
 */
import { CrudService } from '../base/CrudService';
/**
 * RoleService
 * Handles role CRUD operations
 */
export class RoleService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RoleService.DEFAULT_SERVICE_PATH,
            basePath: RoleService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET ALL ====================
    /**
     * Get all roles
     * GET api/roles
     */
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    /**
     * Get all roles with full response
     */
    getAllRaw() {
        const url = this.buildUrl();
        return this.http.get(url);
    }
    // ==================== GET BY ID ====================
    /**
     * Get role by ID
     * GET api/roles/{id}
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Role ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get role by ID with full response
     */
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== GET VIEW ====================
    /**
     * Get all role views
     * GET api/roles/view
     */
    async getView() {
        const response = await this.getViewRaw();
        return response.data ?? [];
    }
    /**
     * Get all role views with full response
     */
    getViewRaw() {
        const endpoint = this.getEndpoint('view', 'view');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEW BY ID ====================
    /**
     * Get role view by ID
     * GET api/roles/view/{id}
     */
    async getRoleView(id) {
        const response = await this.getRoleViewRaw(id);
        if (!response.data) {
            throw new Error(`Role ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get role view by ID with full response
     */
    getRoleViewRaw(id) {
        const endpoint = this.getEndpoint('view-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== CREATE ROLE ====================
    /**
     * Create a new role
     * POST api/roles
     */
    async create(data) {
        const response = await this.createRaw(data);
        if (!response.data) {
            throw new Error('Failed to create role');
        }
        return response.data;
    }
    /**
     * Create a new role with full response
     */
    createRaw(data) {
        const url = this.buildUrl();
        return this.http.post(url, data);
    }
    // ==================== UPDATE ROLE ====================
    /**
     * Update existing role
     * PUT api/roles/{id}
     */
    async update(id, data) {
        const response = await this.updateRaw(id, data);
        if (!response.data) {
            throw new Error('Failed to update role');
        }
        return response.data;
    }
    /**
     * Update existing role with full response
     */
    updateRaw(id, data) {
        const url = this.buildUrl(id);
        return this.http.put(url, data);
    }
    // ==================== DELETE ROLE ====================
    /**
     * Delete role
     * DELETE api/roles/{id}
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    /**
     * Delete role with full response
     */
    deleteRaw(id) {
        const url = this.buildUrl(id);
        return this.http.delete(url);
    }
}
RoleService.DEFAULT_SERVICE_PATH = 'users';
RoleService.BASE_PATH = 'api/roles';
//# sourceMappingURL=RoleService.js.map